import React from 'react'

export default(props) => {
    return(
        <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.011 13.8357H14.0576L13.7262 13.4911C14.8969 12.0609 15.6089 10.207 15.6089 8.17563C15.6089 3.66017 12.1149 0 7.80446 0C3.494 0 0 3.66017 0 8.17563C0 12.6911 3.494 16.3513 7.80446 16.3513C9.74357 16.3513 11.5122 15.6067 12.8774 14.3816L13.2087 14.7262V15.7224L19.2098 22L21 20.1246L15.011 13.8357V13.8357Z" fill={props.color}/>
        </svg>
    )
}